import CreateKeyFactor from "@/app/dto/CreateKeyFactor";
import FactorEnum from "@/app/dto/FactorEnum";
import IPhoneNumber from "@/app/dto/IPhoneNumber";
import Property from "@/app/dto/Property";

export default class AuthorizationKeyRequest {
    usedFactors: CreateKeyFactor[];
    checkAccountBlocking: boolean;

    constructor(factors: FactorEnum[], sendOtp: boolean, mobile?: IPhoneNumber, data?: Property[]) {
        this.usedFactors = factors.map(f => new CreateKeyFactor(f, sendOtp, mobile, data));
        this.checkAccountBlocking = true;
    }

}
